import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";

const Styled = styled.div`
  display: flex;
  margin-bottom: 24px;

  .switch {
    width: auto;
    display: flex;
    padding: 6px;
    border-radius: 6px;
    gap: 6px;
    height: 50px;
    background: #e74c3c10;

    &.active {
      background: #2ecc7110;
    }
  }

  .switch-item {
    min-width: 120px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    border-radius: 5px;

    &.active {
      color: #2ecc71;
      background: white;
    }
    &.active.danger {
      color: #e74c3c;
      background: white;
    }
  }
`;

const SwitchTab = ({
  yes = "active",
  no = "disabled",
  value = true,
  onChange = () => "",
}) => {
  const [active, setActive] = useState(false);

  useEffect(() => {
    value !== active && setActive(value);
  }, [value]);

  return (
    <Styled>
      <div className={`switch ${active ? "active" : ""}`}>
        <div
          className={`switch-item ${active ? "active" : ""}`}
          onClick={() => {
            setActive(true);
            onChange(true);
          }}
        >
          {yes}
        </div>
        <div
          className={`switch-item danger ${!active ? "active" : ""}`}
          onClick={() => {
            setActive(false);
            onChange(false);
          }}
        >
          {no}
        </div>
      </div>
    </Styled>
  );
};

export default SwitchTab;
